import { IMPORT_COURSE, UPDATE_COURSE, CURR_COURSEWARE } from '../actionType/index';

const initState = {
  courseInfo: {}, // 当前课程的信息
  coursewareInfo: {} // 当前课件的信息
}

export default (state = initState, action: any) => {
  switch (action.type) {
    case IMPORT_COURSE:
      return Object.assign({}, state, {courseInfo: action.payload});
    case UPDATE_COURSE:
      return Object.assign({}, state, {courseInfo: action.payload});
    case CURR_COURSEWARE: 
      return Object.assign({}, state, {coursewareInfo: action.payload})
    default:
      return state; 
  }
}
// 行为：导入全局的课程信息数据
export const importCourseInfo = (payload: any) => {
  return {
    type: IMPORT_COURSE,
    payload
  };
};
// 行为：导入全局的课程信息数据
export const updateCourseInfo = (payload: any) => {
  return {
    type: UPDATE_COURSE,
    payload
  };
}; 
// 行为：导入全局的课程信息数据
export const currCoursewareInfo = (payload: any) => {
  return {
    type: CURR_COURSEWARE,
    payload
  };
};